import { IClip } from '../YoutubeCard/YoutubeCard';
import { TV, Wrapper } from './YoutubePlayer.style';

export type YoutubePlayerProps = {
  clip?: IClip;
};

export function YoutubePlayer(props: YoutubePlayerProps) {
  const { clip } = props;

  function renderPlayer() {
    if (!clip) return null;

    const { url, title } = clip;

    // Append autoplay=1 to the URL
    const autoplayUrl = `${url}${url.includes('?') ? '&' : '?'}autoplay=1`;

    return (
      <iframe
        width='100%'
        height='500'
        src={autoplayUrl}
        title={title}
        frameBorder='0'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
      ></iframe>
    );
  }

  return (
    <Wrapper className='YoutubePlayer-wrapper' data-testid='YoutubePlayer-wrapper'>
      <TV>{renderPlayer()}</TV>
    </Wrapper>
  );
}

export default YoutubePlayer;
